<gl-base-modal (closeModal)="onClose()" class="sendToTransModal">
  @if (!isTransId && !isOfferMenu) {
    <div class="content">
      <p class="error">{{ 'transId_required' | translate }}</p>
    </div>
  }
  @if (isTransId && isOfferMenu) {
    <div class="content">
      <h2 class="title">{{ 'publish_on_trans' | translate }}</h2>
      <div class="buttons offerMenu">
        <button type="button" class="button" (click)="startNewFreight()" normal-outline-button>
          {{ 'add_offer' | translate }}
        </button>
        <button type="button" class="button" (click)="openContractorList()" normal-outline-button>
          {{ 'send_order' | translate }}
        </button>
      </div>
    </div>
  }
  @if (isTransForm) {
    <div class="content">
      @if (isOrder) {
        <h2 class="title">{{ 'order_publication' | translate }}</h2>
      }
      @if (!isOrder) {
        <h2 class="title">{{ 'offer_publication' | translate }}</h2>
      }
      <gl-trans-form (submitForm)="transFormSubmit($event)" [isOrder]="isOrder"></gl-trans-form>
    </div>
  }
  @if (isContractorList && isContractorListEmpty) {
    <div class="content">
      <p>{{ 'contractors_list_empty' | translate }}</p>
    </div>
  }
  @if (isContractorList && !isContractorListEmpty) {
    <div class="content">
      <h2 class="title">{{ 'choose_contractor' | translate }}</h2>
      <div class="contractorListContainer">
        <form [formGroup]="form" class="contractorForm">
          <ul class="contractorsList">
            @for (contractor of contractorListData; track contractor; let i = $index) {
              <li class="contractorListElement">
                <gl-radio-button class="radioButton" [value]="contractor.company?.id" formControlName="radioOption">
                  {{ contractor.name }}
                </gl-radio-button>
              </li>
            }
          </ul>
        </form>
      </div>
      <div class="buttons right">
        <button type="button" (click)="startNewOrder()" normal-outline-button>
          {{ 'choose' | translate }}
        </button>
      </div>
    </div>
  }
  @if (isSuccess) {
    <div class="content infoContainer">
      @if (isOrder) {
        <h2 class="title">{{ 'order_publication' | translate }}</h2>
        <p>{{ 'order_success' | translate }}</p>
      }
      @if (!isOrder) {
        <h2 class="title">{{ 'offer_publication' | translate }}</h2>
        <p>{{ 'offer_success' | translate }}</p>
      }
      <div class="buttons">
        <button type="button" (click)="onClose()" normal-outline-button>
          {{ 'close' | translate }}
        </button>
      </div>
    </div>
  }
  @if (isError) {
    <div class="content infoContainer">
      <h2 class="title">{{ 'error' | translate }}</h2>
      <p>{{ 'request_error' | translate }}</p>
      <div class="buttons">
        <button type="button" (click)="onClose()" normal-outline-button>
          {{ 'close' | translate }}
        </button>
      </div>
    </div>
  }
  @if (isNoAttachment) {
    <div class="content infoContainer">
      @if (isOrder) {
        <h2 class="title">{{ 'order_publication' | translate }}</h2>
      }
      @if (!isOrder) {
        <h2 class="title">{{ 'offer_publication' | translate }}</h2>
      }
      <p>{{ 'no_attachment' | translate }}</p>
      <div class="buttons">
        <button type="button" (click)="onClose()" normal-outline-button>
          {{ 'close' | translate }}
        </button>
      </div>
    </div>
  }
</gl-base-modal>
